import React from 'react'
import { Redirect, Route, Switch, useLocation } from 'react-router-dom'
import { linkBuilder, staticLinks } from 'shared/linkBuilder'
import { useRouteTransition } from '../app/hooks/routesTransition'

import AwaitingVerification from '../pages/auth/AwaitingVerification'
import ResetEmailSent from '../pages/auth/reset-password/ResetEmailSent'
import ResetPassword from '../pages/auth/reset-password/ResetPassword'
import ResetPasswordForm from '../pages/auth/reset-password/ResetPasswordForm'
import SignUp from '../pages/auth/SignUp'
import { VerifyAccountPublic } from '../pages/auth/VerifyAccount'
import { LoginPage } from '../pages/auth/login/LoginPage'
import { AuthSuccess } from '../pages/auth/components/AuthSuccess'
import {
  AuthFailed,
  authFailureRouteExpression
} from '../pages/auth/components/AuthFailed'
import { NoOrganisationPage } from './navigation/NotFoundRoutes'
import { customSMTPSenderTokenVerificationQueryParam } from '../pages/account/notifications-tab/CustomSMTP'

export const LooopPublicRoutes: React.FC<{}> = () => {
  const location = useLocation()
  const { RouteTransition } = useRouteTransition(
    location,
    'reactSpring__transition__wrapper--unauth'
  )

  return (
    <RouteTransition>
      <Switch location={location}>
        <Route path="/login" component={LoginPage} exact />
        <Route path="/login/:secretSelfSignupToken" component={LoginPage} />
        <Route
          path="/emailLink/:userId/reset/:token"
          exact
          render={(props) => {
            return (
              <Redirect
                to={linkBuilder.resetPasswordForm(
                  Number(props.match.params.userId),
                  props.match.params.token
                )}
              />
            )
          }}
        />
        <Route
          path="/emailLink/:userId/activate/:token"
          exact
          render={(props) => {
            return (
              <Redirect
                to={linkBuilder.activateUser(
                  Number(props.match.params.userId),
                  props.match.params.token
                )}
              />
            )
          }}
        />
        <Route
          path="/emailLink/:userId/verifyEmailAddress/:token"
          exact
          render={(props) => {
            return (
              <Redirect
                to={linkBuilder.verifyUser(
                  Number(props.match.params.userId),
                  props.match.params.token
                )}
              />
            )
          }}
        />
        <Route
          path="/emailLink/:userId/verifyAccount/:token"
          exact
          render={(props) => {
            return (
              <Redirect
                to={linkBuilder.verifyUser(
                  Number(props.match.params.userId),
                  props.match.params.token
                )}
              />
            )
          }}
        />
        <Route path="/authSuccessCallback/:sid" exact component={AuthSuccess} />
        <Route path={authFailureRouteExpression} exact component={AuthFailed} />
        <Route path="/signup" exact component={SignUp} />
        <Route path="/signup/email/:email" component={SignUp} />
        <Route
          exact
          path="/resetPassword/:userIdentity?"
          component={ResetPassword}
        />
        <Route
          exact
          path="/resetPassword/sent/:email"
          component={ResetEmailSent}
        />
        <Route
          exact
          path="/resetPassword/:userId(\d+)/:token"
          component={ResetPasswordForm}
        />
        <Route
          exact
          path="/activate/:userId/:token"
          component={ResetPasswordForm}
        />
        <Route
          path="/awaitingVerification/:email"
          component={AwaitingVerification}
        />
        <Route
          path="/verifyAccount/:userId/:token"
          component={VerifyAccountPublic}
        />
        <Route
          path="/emailLink/verifyCustomSMTPDefaultSender/:token"
          exact
          render={(props) => {
            return (
              <Redirect
                to={`/account/notifications?${customSMTPSenderTokenVerificationQueryParam}=${props.match.params.token}`}
              />
            )
          }}
        />
        <Route
          path={staticLinks.noOrganisation}
          exact
          component={NoOrganisationPage}
        />
        <Route path="/self-signup/:token" component={LoginPage} />
        {/* when nothing else matched */}
        <Route component={LoginPage} />
      </Switch>
    </RouteTransition>
  )
}
